// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"AN-z","smallCardRow":"BN-z","largeCardRow":"CN-z","productSearchRow":"DN-z","curatedRow":"EN-z"};